'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _UISection = require('../section/UISection');

var _UISection2 = _interopRequireDefault(_UISection);

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _iconName = require('../utils/propTypes/iconName');

var _BrowserTest = require('../utils/BrowserTest');

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var _colors = require('HubStyleTokens/colors');

var _sizes = require('HubStyleTokens/sizes');

var _theme = require('HubStyleTokens/theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CONTENT_PADDING_X = 20;

var STYLES_FOR_USE = {
  hover: {
    backgroundColor: _colors.CALYPSO_LIGHT,
    border: '1px dashed ' + _colors.CALYPSO,
    iconColor: _theme.BASE_LINK_COLOR
  },
  processing: {
    border: '1px solid ' + _colors.GYPSUM,
    iconColor: _colors.EERIE
  },
  selected: {
    border: '1px solid ' + _colors.GYPSUM,
    color: _colors.OBSIDIAN,
    iconColor: _colors.OBSIDIAN
  },
  error: {
    backgroundColor: _colors.CANDY_APPLE_LIGHT,
    border: '1px dashed ' + _colors.CANDY_APPLE_DARK,
    color: _theme.BASE_FONT_COLOR,
    iconColor: _colors.CANDY_APPLE_DARK
  },
  success: {
    backgroundColor: _colors.OZ_LIGHT,
    border: '1px dashed ' + _colors.OZ_DARK,
    color: _theme.BASE_FONT_COLOR,
    iconColor: _colors.OZ
  }
};

var Outer = (0, _styledComponents2.default)(function (props) {
  var __variantStyles = props.variantStyles,
      rest = _objectWithoutProperties(props, ['variantStyles']);

  return _react2.default.createElement(_UISection2.default, rest);
}).withConfig({
  displayName: 'UIDropZone__Outer'
})(['display:flex;flex-direction:column;background-color:', ';border:', ';border-radius:4px;color:', ';position:relative;'], function (_ref) {
  var variantStyles = _ref.variantStyles;
  return variantStyles.backgroundColor || _colors.GYPSUM;
}, function (_ref2) {
  var variantStyles = _ref2.variantStyles;
  return variantStyles.border || '1px dashed ' + _colors.SLINKY;
}, function (_ref3) {
  var variantStyles = _ref3.variantStyles;
  return variantStyles.color || _colors.EERIE;
});

// Fix for #6763: Under IE11, images don't respect `max-width: 100%` in this flex container.
var imgWidthMixin = (0, _styledComponents.css)(['img{max-width:', 'px;}'], function (_ref4) {
  var contentWidth = _ref4.contentWidth;
  return contentWidth - CONTENT_PADDING_X * 2;
});

var Content = _styledComponents2.default.div.withConfig({
  displayName: 'UIDropZone__Content'
})(['display:flex;min-height:', ';flex-direction:', ';align-items:center;justify-content:center;text-align:center;padding:24px ', 'px;', ''], function (_ref5) {
  var size = _ref5.size;
  return size === 'small' ? _sizes.DROP_SMALL_HEIGHT : _sizes.DROP_LARGE_HEIGHT;
}, function (_ref6) {
  var size = _ref6.size;
  return size === 'small' ? 'row' : 'column';
}, CONTENT_PADDING_X, function (_ref7) {
  var contentWidth = _ref7.contentWidth;
  return contentWidth && imgWidthMixin;
});

var Icon = (0, _styledComponents2.default)(function (props) {
  var __dropSize = props.dropSize,
      rest = _objectWithoutProperties(props, ['dropSize']);

  return _react2.default.createElement(_UIIcon2.default, rest);
}).withConfig({
  displayName: 'UIDropZone__Icon'
})(['padding-right:', ';padding-bottom:', ';'], function (_ref8) {
  var dropSize = _ref8.dropSize;
  return dropSize === 'small' && '12px';
}, function (_ref9) {
  var dropSize = _ref9.dropSize;
  return dropSize === 'large' && '16px';
});

var Body = _styledComponents2.default.div.withConfig({
  displayName: 'UIDropZone__Body'
})(['display:flex;flex-direction:column;']);

var emptyObject = {};

var UIDropZone = _react2.default.createClass({
  displayName: 'UIDropZone',

  propTypes: {
    children: _react.PropTypes.node,
    contentClassName: _react.PropTypes.string,
    iconName: (0, _iconName.getIconNamePropType)(),
    iconSize: _UIIcon2.default.propTypes.size,
    size: (0, _tshirtSize.propTypeForSizes)(['sm', 'lg']).isRequired,
    use: _react.PropTypes.oneOf(['default', 'hover', 'processing', 'selected', 'error', 'success']).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      size: 'small',
      use: 'default'
    };
  },
  getInitialState: function getInitialState() {
    return {
      contentWidth: null
    };
  },
  componentDidMount: function componentDidMount() {
    this.computeWidth();
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    // ⚠️ This condition prevents infinite loops! ⚠️
    if (prevState.contentWidth === this.state.contentWidth) {
      this.computeWidth();
    }
  },
  computeWidth: function computeWidth() {
    if (!(0, _BrowserTest.isIE11)()) return;
    var contentWidth = this._contentEl.offsetWidth;
    if (contentWidth && contentWidth !== this.state.contentWidth) {
      this.setState({ contentWidth: contentWidth });
    }
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        children = _props.children,
        className = _props.className,
        contentClassName = _props.contentClassName,
        iconName = _props.iconName,
        iconSize = _props.iconSize,
        size = _props.size,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['children', 'className', 'contentClassName', 'iconName', 'iconSize', 'size', 'use']);

    var contentWidth = this.state.contentWidth;


    var longhandSize = (0, _tshirtSize.toLonghandSize)(size);
    var computedClassName = (0, _classNames2.default)('private-drop-zone', className, {
      'private-drop-zone--large': size === 'large'
    });

    var variantStyles = STYLES_FOR_USE[use] || emptyObject;

    return _react2.default.createElement(
      Outer,
      _extends({}, rest, {
        className: computedClassName,
        variantStyles: variantStyles
      }),
      _react2.default.createElement(
        Content,
        {
          className: (0, _classNames2.default)('private-drop-zone__content', contentClassName),
          innerRef: function innerRef(ref) {
            _this._contentEl = ref;
          },
          contentWidth: contentWidth,
          size: size
        },
        iconName ? _react2.default.createElement(Icon, {
          name: iconName,
          dropSize: longhandSize,
          size: iconSize || (longhandSize === 'small' ? 24 : 48),
          color: variantStyles.iconColor
        }) : null,
        _react2.default.createElement(
          Body,
          null,
          children
        )
      )
    );
  }
});

exports.default = UIDropZone;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/drop/UIDropZone.js
// module id = 554
// module chunks = 171